
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Filter, Users } from 'lucide-react';
import { UserProfile } from '@/types';
import SwipeCard from '../SwipeCard';
import CompatibilityBreakdown from './CompatibilityBreakdown';

interface DiscoveryViewProps {
  currentProfile: UserProfile & { matchScore?: any };
  currentProfileIndex: number;
  profiles: (UserProfile & { matchScore?: any })[];
  onLike: (profileId: string) => void;
  onPass: (profileId: string) => void;
  swipeKey: number;
}

const DiscoveryView: React.FC<DiscoveryViewProps> = ({
  currentProfile,
  currentProfileIndex,
  profiles,
  onLike,
  onPass,
  swipeKey
}) => {
  if (currentProfileIndex >= profiles.length) {
    return (
      <div className="text-center py-12">
        <Users className="h-16 w-16 mx-auto mb-4 opacity-20" />
        <h3 className="text-lg font-medium mb-2">No more profiles to show</h3>
        <p className="text-muted-foreground mb-6">
          Check back later for more musician matches
        </p>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Start Over
        </Button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-8">
      <div className="touch-none" key={swipeKey}>
        <SwipeCard 
          profile={currentProfile}
          onLike={onLike}
          onPass={onPass}
        />
      </div>
      
      <div className="space-y-6">
        <CompatibilityBreakdown currentProfile={currentProfile} />
        
        <Button variant="outline" className="w-full gap-2">
          <Filter className="h-4 w-4" />
          <span>Adjust Match Preferences</span>
        </Button>
      </div>
    </div>
  );
};

export default DiscoveryView;
